var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragAndDropPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "600px",
    height: "400px",
    viewBox: "0 0 600 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "step2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "button",
    filter: "url(#filter0_d_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "button_fill",
    x: 364,
    y: 286,
    width: 151,
    height: 32,
    rx: 5,
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.5,
    y: 286.5,
    width: 150,
    height: 31,
    rx: 4.5,
    stroke: "#919191"
  })), /*#__PURE__*/React.createElement("path", {
    className: "imageSmall",
    d: "M85 288.857C85 287.569 85.6321 286.334 86.7574 285.423C87.8826 284.512 89.4087 284 91 284H127C128.591 284 130.117 284.512 131.243 285.423C132.368 286.334 133 287.569 133 288.857V313.143C133 314.431 132.368 315.666 131.243 316.577C130.117 317.488 128.591 318 127 318H91C89.4087 318 87.8826 317.488 86.7574 316.577C85.6321 315.666 85 314.431 85 313.143V288.857V288.857ZM88 310.714V313.143C88 313.787 88.3161 314.405 88.8787 314.86C89.4413 315.316 90.2044 315.571 91 315.571H127C127.796 315.571 128.559 315.316 129.121 314.86C129.684 314.405 130 313.787 130 313.143V304.643L118.669 299.914C118.388 299.8 118.069 299.761 117.758 299.801C117.448 299.842 117.161 299.96 116.938 300.14L105.808 309.15L97.828 304.847C97.5399 304.692 97.1943 304.622 96.8498 304.649C96.5053 304.677 96.1832 304.8 95.938 304.997L88 310.714ZM103 294.929C103 293.962 102.526 293.036 101.682 292.353C100.838 291.67 99.6935 291.286 98.5 291.286C97.3065 291.286 96.1619 291.67 95.318 292.353C94.4741 293.036 94 293.962 94 294.929C94 295.895 94.4741 296.821 95.318 297.504C96.1619 298.188 97.3065 298.571 98.5 298.571C99.6935 298.571 100.838 298.188 101.682 297.504C102.526 296.821 103 295.895 103 294.929Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "step1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "dropBox",
    filter: "url(#filter1_d_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 72,
    width: 430,
    height: 184,
    rx: 10,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dropBox_stroke",
    x: 86,
    y: 73,
    width: 428,
    height: 182,
    rx: 9,
    stroke: "#9F9F9F",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cloudIcon",
    d: "M301.5 146C297.128 146.014 292.906 147.59 289.595 150.445C287.058 152.632 285.219 155.48 284.745 158.339C279.194 159.565 275 164.401 275 170.241C275 177.025 280.658 182.438 287.525 182.438H317.026C323.038 182.438 328 177.701 328 171.748C328 166.329 323.886 161.913 318.612 161.168C317.807 152.622 310.411 146 301.5 146ZM309.298 163.046C309.452 163.2 309.574 163.383 309.657 163.584C309.74 163.785 309.783 164.001 309.783 164.219C309.783 164.437 309.74 164.652 309.657 164.853C309.574 165.055 309.452 165.237 309.298 165.391C309.144 165.545 308.961 165.668 308.76 165.751C308.558 165.834 308.343 165.877 308.125 165.877C307.907 165.877 307.692 165.834 307.49 165.751C307.289 165.668 307.106 165.545 306.952 165.391L303.156 161.592V174.156C303.156 174.596 302.982 175.017 302.671 175.327C302.361 175.638 301.939 175.812 301.5 175.812C301.061 175.812 300.639 175.638 300.329 175.327C300.018 175.017 299.844 174.596 299.844 174.156V161.592L296.048 165.391C295.737 165.702 295.315 165.877 294.875 165.877C294.435 165.877 294.013 165.702 293.702 165.391C293.391 165.08 293.217 164.659 293.217 164.219C293.217 163.779 293.391 163.357 293.702 163.046L300.327 156.421C300.481 156.267 300.664 156.145 300.865 156.061C301.066 155.978 301.282 155.935 301.5 155.935C301.718 155.935 301.934 155.978 302.135 156.061C302.336 156.145 302.519 156.267 302.673 156.421L309.298 163.046Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    className: "image",
    d: "M332 129.5C332 125.654 333.844 121.966 337.126 119.247C340.408 116.528 344.859 115 349.5 115H454.5C459.141 115 463.592 116.528 466.874 119.247C470.156 121.966 472 125.654 472 129.5V202C472 205.846 470.156 209.534 466.874 212.253C463.592 214.972 459.141 216.5 454.5 216.5H349.5C344.859 216.5 340.408 214.972 337.126 212.253C333.844 209.534 332 205.846 332 202V129.5V129.5ZM340.75 194.75V202C340.75 203.923 341.672 205.767 343.313 207.127C344.954 208.486 347.179 209.25 349.5 209.25H454.5C456.821 209.25 459.046 208.486 460.687 207.127C462.328 205.767 463.25 203.923 463.25 202V176.625L430.201 162.509C429.381 162.169 428.452 162.051 427.546 162.172C426.64 162.293 425.802 162.647 425.152 163.183L392.69 190.081L369.415 177.234C368.575 176.77 367.567 176.562 366.562 176.644C365.557 176.726 364.618 177.093 363.902 177.683L340.75 194.75ZM384.5 147.625C384.5 144.741 383.117 141.975 380.656 139.935C378.194 137.896 374.856 136.75 371.375 136.75C367.894 136.75 364.556 137.896 362.094 139.935C359.633 141.975 358.25 144.741 358.25 147.625C358.25 150.509 359.633 153.275 362.094 155.315C364.556 157.354 367.894 158.5 371.375 158.5C374.856 158.5 378.194 157.354 380.656 155.315C383.117 153.275 384.5 150.509 384.5 147.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pointer",
    d: "M467.982 211.158L468.103 211.665L468.605 211.523L468.648 211.511C468.649 211.511 468.649 211.511 468.649 211.511C468.952 211.426 469.317 211.34 469.565 211.331L469.565 211.331C469.776 211.323 470.003 211.368 470.197 211.422C470.374 211.472 470.515 211.581 470.618 211.726L470.832 212.028L471.184 211.91L471.307 211.869C471.605 211.773 471.969 211.687 472.229 211.726L472.229 211.726C472.489 211.764 472.791 211.95 473.024 212.125C473.11 212.189 473.186 212.25 473.249 212.303L473.441 212.465L473.687 212.407L474.253 212.273C474.253 212.273 474.253 212.273 474.253 212.273C474.457 212.224 474.669 212.219 474.875 212.258C475.081 212.296 475.276 212.377 475.449 212.496C475.622 212.615 475.768 212.768 475.877 212.947C475.987 213.125 476.058 213.325 476.086 213.532C476.086 213.532 476.086 213.532 476.086 213.532L476.449 216.237L476.449 216.237C476.505 216.654 476.473 217.079 476.354 217.483L476.354 217.483L475.561 220.18L475.561 220.181C475.511 220.35 475.417 220.503 475.289 220.624C475.162 220.745 475.004 220.831 474.833 220.871C474.833 220.871 474.833 220.871 474.833 220.871L468.701 222.328C468.52 222.371 468.331 222.362 468.155 222.304C467.979 222.245 467.822 222.139 467.703 221.996L467.703 221.996L465.959 219.913L465.947 219.898L465.933 219.884L462.552 216.422C462.551 216.422 462.551 216.422 462.551 216.422C462.379 216.244 462.277 216.01 462.266 215.762C462.254 215.515 462.333 215.272 462.487 215.078C462.642 214.885 462.862 214.755 463.106 214.712C463.35 214.669 463.601 214.717 463.812 214.846C463.812 214.846 463.812 214.847 463.812 214.847L465.686 216L466.713 216.633L466.434 215.459L464.922 209.093C464.846 208.77 464.9 208.431 465.074 208.148C465.248 207.866 465.527 207.664 465.85 207.588C466.172 207.511 466.512 207.566 466.794 207.74C467.077 207.914 467.278 208.193 467.355 208.515L467.982 211.158Z",
    fill: "white",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2",
    x: 360,
    y: 286,
    width: 159,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_2",
    x: 81,
    y: 72,
    width: 438,
    height: 192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDropPicture);
export default __webpack_public_path__ + "static/media/dragAndDropPicture.d486d1f5d07ce076be6f97ccb965bea1.svg";
export { ForwardRef as ReactComponent };